<template lang="pug">
  b-card
    b-row.flex(slot="header")
      .col-sm-12.col-md-6.col-lg-6.col-xl-3.mb-1
        b-input-group(:prepend="$t('ui.account_id')" size="sm")
          DebounceInput(
            type="text"
            ref="search_id"
            :placeholder='$t("ui.account_id")'
            v-model="search_id"
            size="sm"
            @keyup.enter.native="search"
          )
      .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
        b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
      .col-sm-12.col-md-6.col-lg-6.col-xl-2
        SubmitButton(:loading="loading" icon="fa fa-search" :text="$t('ui.search')" isModal=false type="button" @click="search")
    b-form(novalidate @submit.prevent="submit" :disabled="!submission.success")
      b-row
        .col-sm-12.col-md-12.col-lg-12.col-xl-12
          panel(:title='$t("title.account_profile")' :bodyClass="'childBody'")
            b-row.flex
              .col-sm-12.col-md-6.col-lg-6.col-xl-6.mb-2
                label {{ $t("ui.account_id") }}
                b-input-group.input-group-sm
                  template(v-if="accountType != 6" v-slot:prepend)
                    b-input-group-text {{ $store.getters.accountID.toUpperCase() }}
                  DebounceInput(
                    type="text"
                    ref="account_id"
                    :dirty="$v.account_id.$dirty"
                    :error="$v.account_id.$error"
                    :placeholder='$t("ui.account_id")'
                    v-model.trim.lazy="$v.account_id.$model"
                    :maxLength="$v.account_id.$params.maxLength.max"
                    :disabled="loading"
                  )
                  .input-group-append(v-if="accountType == 6" style="cursor: pointer;")
                    b-button.btn.btn-outline-secondary.btn-sm(style="border-top-right-radius: 3px;border-bottom-right-radius: 3px;" @click="randomID")
                      i.fas.fa-random
                  ValidateResult(:value="$v.account_id" :name="$t('ui.account_id')")
              .col-sm-12.col-md-6.col-lg-6.col-xl-6.mb-2
                .d-flex.align-items-center.justify-content-between.mb-1
                  label.mb-0 {{ $t("ui.password") }}
                  small(v-if="password" :class="passwordStrength.badgeClass") {{ passwordStrength.strength }} ({{ passwordStrength.score }}/100)
                b-input-group.input-group-sm
                  DebounceInput(
                    :type=" (isPWShown) ? 'password' : 'text'"
                    ref="password"
                    :dirty="$v.password.$dirty"
                    :error="$v.password.$error"
                    :placeholder='$t("ui.password")'
                    v-model.trim.lazy="$v.password.$model"
                    :maxLength="$v.password.$params.maxLength.max"
                    :disabled="loading"
                  )
                  .input-group-append(style="cursor: pointer;")
                    b-button.btn.btn-outline-secondary.btn-sm(:pressed.sync="isPWShown" style="border-top-right-radius: 0;border-bottom-right-radius: 0;")
                      i.fa(:class=" (isPWShown) ? 'icon-eye-open fa-eye' : 'icon-eye-close fa-eye-slash'")
                    PasswordRules
                  ValidateResult(:value="$v.password" :name="$t('ui.password')" :errors="passwordErrors")
              .col-sm-12.col-md-6.col-lg-6.col-xl-6.mb-2
                label {{ $t("ui.full_name") }}
                DebounceInput(
                  type="text"
                  ref="full_name"
                  :dirty="$v.full_name.$dirty"
                  :error="$v.full_name.$error"
                  :placeholder='$t("ui.full_name")'
                  v-model.trim.lazy="$v.full_name.$model"
                  :maxLength="$v.full_name.$params.maxLength.max"
                  :disabled="loading"
                )
                ValidateResult(:value="$v.full_name" :name="$t('ui.full_name')")
              //- .col-sm-12.col-md-6.col-lg-6.col-xl-6.mb-2
              //-   label {{ $t("ui.confirm_password") }}
              //-   b-input-group.input-group-sm
              //-     DebounceInput(
              //-       :type=" (isCPWShown) ? 'password' : 'text'"
              //-       ref="confirm_password"
              //-       :dirty="$v.confirm_password.$dirty"
              //-       :error="$v.confirm_password.$error"
              //-       :placeholder='$t("ui.confirm_password")'
              //-       v-model.trim.lazy="$v.confirm_password.$model"
              //-       :disabled="loading"
              //-     )
              //-     .input-group-append(style="cursor: pointer;")
              //-       b-button.btn.btn-outline-secondary.btn-sm(:pressed.sync="isCPWShown" style="border-top-right-radius: 3px;border-bottom-right-radius: 3px;")
              //-         i.fa(:class=" (isCPWShown) ? 'icon-eye-open fa-eye' : 'icon-eye-close fa-eye-slash'")
              //-     ValidateResult(:value="$v.confirm_password" :name="$t('ui.confirm_password')" :name2="$t('ui.password')")
              .col-sm-12.col-md-6.col-lg-6.col-xl-6.mb-2
                label {{ $t("ui.contact_phone") }}
                DebounceInput(
                  type="text"
                  ref="contact_phone"
                  :dirty="$v.contact_phone.$dirty"
                  :error="$v.contact_phone.$error"
                  :placeholder='$t("ui.contact_phone")'
                  v-model.trim.lazy="$v.contact_phone.$model"
                  :maxLength="$v.contact_phone.$params.maxLength.max"
                  :disabled="loading"
                )
                ValidateResult(:value="$v.contact_phone" :name="$t('ui.contact_phone')")
              //- .col-sm-12.col-md-6.col-lg-6.col-xl-6.mb-2(v-if="!$helpers.isAgentLevel()")
              //-   label {{ $t("ui.contact_email") }}
              //-   DebounceInput(
              //-     type="text"
              //-     ref="contact_email"
              //-     :dirty="$v.contact_email.$dirty"
              //-     :error="$v.contact_email.$error"
              //-     :placeholder='$t("ui.contact_email")'
              //-     v-model.trim.lazy="$v.contact_email.$model"
              //-     :disabled="loading"
              //-   )
              //-   ValidateResult(:value="$v.contact_email" :name="$t('ui.contact_email')")
              .col-sm-12.col-md-6.col-lg-6.col-xl-6
                MoneyInput(
                  ref="credit_limit"
                  :dirty="$v.credit_limit.$dirty"
                  :error="$v.credit_limit.$error"
                  :placeholder='$t("ui.credit_limit")'
                  v-model="$v.credit_limit.$model"
                  :title="title_credit_limit"
                  :disabled="loading"
                )
                ValidateResult(:value="$v.credit_limit" :name="$t('ui.credit_limit')")
              .col-sm-12.col-md-6.col-lg-6.col-xl-6(v-if="!$helpers.isAgentLevel()")
                MoneyInput(
                  ref="member_credit_limit"
                  :dirty="$v.member_credit_limit.$dirty"
                  :error="$v.member_credit_limit.$error"
                  :placeholder='$t("ui.member_credit_limit")'
                  v-model="$v.member_credit_limit.$model"
                  :title="title_member_credit_limit"
                  :disabled="loading"
                )
                ValidateResult(:value="$v.member_credit_limit" :name="$t('ui.member_credit_limit')")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-2(v-if="!$helpers.isAgentLevel()")
                .textfield-box
                  label.mb-2 {{ $t('ui.payment_option') }}
                  b-form-checkbox-group(
                    ref="payment_option"
                    :class="{ 'is-invalid': $v.payment_option.$dirty == true && $v.payment_option.$error == true, 'is-valid': $v.payment_option.$dirty == true && $v.payment_option.$error == false }"
                    v-model.trim.lazy="$v.payment_option.$model = isDayEnabled"
                    :disabled="loading"
                    :options="isDayEnabledList"
                  )
                  ValidateResult.text-left(:value="$v.payment_option" :name="$t('ui.payment_option')")
            b-row.flex(v-if="$helpers.isAgentLevel()")
              .col-sm-12.col-md-6.col-lg-6.col-xl-6.mb-2
                label {{ $t("ui.win_limit") }}
                b-form-select(
                  size="sm"
                  v-model.trim.lazy="$v.win_limit.$model"
                )
                  option(value="0") {{ $t("ui.win_limit_0") }}
                  option(value="1") {{ $t("ui.win_limit_1") }}
                  option(value="2") {{ $t("ui.win_limit_2") }}
                  option(value="5") {{ $t("ui.win_limit_5") }}
                  option(value="10") {{ $t("ui.win_limit_10") }}
                  option(value="20") {{ $t("ui.win_limit_20") }}
                small.text-muted.text-danger.mr-1 {{ $t("ui.win_limit_tooltips") }}
                i.fa.fa-info-circle(aria-hidden="true" :title='$t("ui.win_limit_tooltips1")')
                ValidateResult(:value="$v.win_limit" :name="$t('ui.win_limit')")
              .col-sm-12.col-md-6.col-lg-6.col-xl-6.mb-2
                .form-group
                  label.mb-2 {{ $t('ui.daily_reset') }}
                  br
                  label.switch.switch-label.switch-success
                    input(type="checkbox" class="switch-input" v-model="daily_reset" :disabled="loading")
                    span(class="switch-slider" :data-checked="$t('ui.on')" :data-unchecked="$t('ui.off')")
        .col-sm-12.col-md-12.col-lg-12.col-xl-12
          ul.nav.nav-pills.mb-2
            li.nav-item
              a.nav-link.active(href="#nav-pt" data-toggle="tab")
                span.d-sm-none {{ $t("ui.position_taking") }}
                span.d-sm-block.d-none {{ $t("ui.position_taking") }}
            li.nav-item
              a.nav-link(href="#nav-bl" data-toggle="tab")
                span.d-sm-none {{ $t("ui.bet_limit") }}
                span.d-sm-block.d-none {{ $t("ui.bet_limit") }}
            li.nav-item
              a.nav-link(href="#nav-cm" data-toggle="tab")
                span.d-sm-none {{ $t("ui.commission") }}
                span.d-sm-block.d-none {{ $t("ui.commission") }}
          .tab-content.rounded.bg-white
            #nav-pt.tab-pane.fade.active.show
              ptSettings(ref="ptSettings" :loading="loading")
            #nav-bl.tab-pane.fade
              betLimitSettings(ref="betLimitSettings" :loading="loading")
            #nav-cm.tab-pane.fade
              commSettings(ref="commSettings" :loading="loading")
        .col-sm-12.col-md-12.col-lg-12.col-xl-12
          b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
        .col-sm-12.col-md-12.col-lg-12.col-xl-12
          SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.reset')" isModal=false type="button"  @click="clear()")
          SubmitButton.ml-2(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=false type="button" @click="submit" :disabled="loading")
</template>

<script>
import config from "@/config"
import {
  required,
  minValue,
  maxValue,
  minLength,
  maxLength,
  email,
  numeric,
  sameAs,
  helpers,
  requiredIf
} from "vuelidate/lib/validators"
import SubmitButton from "@/library/SubmitButton"
import ValidateResult from "@/library/ValidateResult"
import DebounceInput from "@/library/DebounceInput"
import MoneyInput from "@/library/MoneyInput2"
import PasswordRules from "@/library/PasswordRules"
import ptSettings from "@/components/positionTaking/ptSettings.vue"
import commSettings from "@/components/commission/commSettings.vue"
import betLimitSettings from "@/components/betLimit/betLimitSettings.vue"

// const containAlphaNum = helpers.regex("containAlphaNum", /^(?=.*\d)(?=.*[a-zA-Z])/)

const onlySmallCapsAlphaNumRegex = /^[a-z0-9]*$/

// Custom validator to block JavaScript injection
const noJavaScriptInjection = (value) => {
  if (!value) return true; // Allow empty values
  
  const dangerousPatterns = [
    /<script[\s\S]*?>[\s\S]*?<\/script>/gi, // Script tags
    /<iframe[\s\S]*?>/gi, // Iframe tags
    /javascript:/gi, // JavaScript protocol
    /on\w+\s*=/gi, // Event handlers (onclick, onerror, onload, etc.)
    /<embed[\s\S]*?>/gi, // Embed tags
    /<object[\s\S]*?>/gi, // Object tags
    /eval\s*\(/gi, // Eval function
    /expression\s*\(/gi, // CSS expression
    /vbscript:/gi, // VBScript protocol
    /data:text\/html/gi, // Data URI with HTML
    /<img[\s\S]*?on\w+/gi, // Image tags with event handlers
    /&lt;script/gi, // HTML encoded script tags
    /&#60;script/gi, // Numeric HTML encoded script tags
    /[<>]/g, // Block angle brackets (HTML tags)
    /[=]/g, // Block equals sign (attribute assignments)
    /%[0-9a-f]{2}/gi, // Block URL encoded characters (like %3C for <)
    /[{}]/g, // Block curly braces (template literals)
    /[\[\]]/g, // Block square brackets
  ];
  
  // Check if the value contains any dangerous patterns
  for (let pattern of dangerousPatterns) {
    if (pattern.test(value)) {
      return false;
    }
  }
  
  return true;
}

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    MoneyInput,
    PasswordRules,
    ptSettings,
    commSettings,
    betLimitSettings
  },
  data() {
    return {
      isPWShown: true,
      isCPWShown: true,
      search_id: this.$store.getters.getSelectedID,
      account_id: "",
      full_name: "",
      password: "",
      // confirm_password: "", 
      contact_phone: "",
      contact_email: "",
      credit_limit: "",
      member_credit_limit: this.$helpers.isAgentLevel() ? "0" : "",
      win_limit: "0",
      daily_reset: 0,
      payment_option: [],
      loading: false,
      passwordErrors: [],
      passwordStrength: { score: 0, strength: "", badgeClass: "text-muted" },
      submission1: {
        success: true,
        status: ""
      },
      submission: {
        success: true,
        status: ""
      },
      searchAcc: false,
      redirect: "/accountList",
      ptJSON: {
        soccer_hdp_upline_pt: 0,
        soccer_hdp_account_pt: 0,
        soccer_hdp_upline_remaining: 0,
        soccer_hdp_account_min: 0,
        soccer_1x2_upline_pt: 0,
        soccer_1x2_account_pt: 0,
        soccer_1x2_upline_remaining: 0,
        soccer_1x2_account_min: 0,
        soccer_others_upline_pt: 0,
        soccer_others_account_pt: 0,
        soccer_others_upline_remaining: 0,
        soccer_others_account_min: 0,
        hdp_mmo_upline_pt: 0,
        hdp_mmo_account_pt: 0,
        hdp_mmo_upline_remaining: 0,
        hdp_mmo_account_min: 0,
        parlay_upline_pt: 0,
        parlay_account_pt: 0,
        parlay_upline_remaining: 0,
        parlay_account_min: 0,
        parlay_mmo_upline_pt: 0,
        parlay_mmo_account_pt: 0,
        parlay_mmo_upline_remaining: 0,
        parlay_mmo_account_min: 0,
        livecasino_upline_pt: 0,
        livecasino_account_pt: 0,
        livecasino_upline_remaining: 0,
        livecasino_account_min: 0,
        slots_upline_pt: 0,
        slots_account_pt: 0,
        slots_upline_remaining: 0,
        slots_account_min: 0,
        lotto_upline_pt: 0,
        lotto_account_pt: 0,
        lotto_upline_remaining: 0,
        lotto_account_min: 0,
        keno_upline_pt: 0,
        keno_account_pt: 0,
        keno_upline_remaining: 0,
        keno_account_min: 0,
        cockfight_upline_pt: 0,
        cockfight_account_pt: 0,
        cockfight_upline_remaining: 0,
        cockfight_account_min: 0,
        lottery_upline_pt: 0,
        lottery_account_pt: 0,
        lottery_upline_remaining: 0,
        lottery_account_min: 0
      },
      cmJSON: {
        comm_sportsbook_hdp_a: 0,
        comm_sportsbook_hdp_b: 0,
        comm_sportsbook_hdp_c: 0,
        comm_sportsbook_hdp_d: 0,
        comm_sportsbook_hdp_e: 0,
        comm_sportsbook_hdp_f: 0,
        comm_sportsbook_hdp_g: 0,
        comm_sportsbook_hdp_h: 0,
        comm_sportsbook_hdp_i: 0,
        comm_sportsbook_hdp_j: 0,
        comm_sportsbook_1x2: 0,
        comm_sportsbook_others: 0,
        comm_sportsbook_hdp_packages: "",
        comm_slots: 0,
        comm_casino: 0,
        comm_lotto: 0,
        comm_keno: 0,
        comm_cockfight: 0,
        comm_lottery_1d: 0,
        comm_lottery_2d: 0,
        comm_lottery_3d: 0,
        comm_lottery_4d: 0,
        comm_tournament: 0
      },
      blJSON: {
        soccer_min_bet: 0,
        soccer_max_bet: 0,
        soccer_max_per_match: 0,
        basketball_min_bet: 0,
        basketball_max_bet: 0,
        basketball_max_per_match: 0,
        tennis_min_bet: 0,
        tennis_max_bet: 0,
        tennis_max_per_match: 0,
        baseball_min_bet: 0,
        baseball_max_bet: 0,
        baseball_max_per_match: 0,
        parlay_min_bet: 0,
        parlay_max_bet: 0,
        parlay_max_per_match: 0,
        esports_min_bet: 0,
        esports_max_bet: 0,
        esports_max_per_match: 0,
        others_min_bet: 0,
        others_max_bet: 0,
        others_max_per_match: 0,
        cs_min_bet: "0",
        cs_max_bet: "0",
        cs_max_per_match: "0",
        livecasino_bet_limit_packages: [],
        lotto_bet_limit_packages: [],
        keno_bet_limit_packages: [],
        cockfight_bet_limit_packages: [],
        lottery_bet_limit_packages: []
      },
      schJSON: {
        schedule_1: true,
        schedule_2: false,
        schedule_3: false,
        schedule_4: false,
        schedule_5: false,
        schedule_6: false,
        schedule_7: false
      }
    };
  },
  validations() {
    return {
      account_id: {
        required,
        onlySmallCapsAlphaNum: helpers.regex(
          "onlySmallCapsAlphaNum",
          onlySmallCapsAlphaNumRegex
        ),
        minLength: minLength(this.accountIdMinLength),
        maxLength: maxLength(this.accountIdMaxLength),
        isSSFormat(value) {
          if (this.accountType == 6) {
            let regex = /^[a-z]*$/
            let checkSSFormat = regex.test(value)
            if(checkSSFormat) {
              return true
            } else {
              return false
            }
          } else {
            return true
          }
        },
        async isExisted(value) {
          if (!value || !onlySmallCapsAlphaNumRegex.test(value)) {
            return true
          }
          const accountId = this.accountType == 6
            ? value
            : this.$store.getters.accountID + value
          const res = await this.$store.dispatch("user/checkDownlineExist", accountId)
          return !res.success
        },
        async isReserved(value) {
          if (!value || this.accountType != 6) {
            return true
          }
          const res = await this.$store.dispatch("user/checkAccountReserved", value)
          return !res.success
        }
      },
      full_name: {
        maxLength: maxLength(30),
        noJavaScriptInjection: helpers.withParams(
          { type: 'noJavaScriptInjection' },
          noJavaScriptInjection
        )
      },
      password: {
        required,
        valid: function(value) {
          if (!helpers.req(value)) return true;
          return this.$helpers.validatePassword(value).isValid;
        },
        // minLength: minLength(8),
        maxLength: maxLength(Number(this.accountType) === 2 ? 20 : 50)
      },
      // confirm_password: {
      //   required,
      //   sameAs: sameAs("password")
      // },
      contact_phone: {
        numeric,
        minLength: minLength(9),
        maxLength: maxLength(20)
      },
      // contact_email: {
      //   email,
      //   maxLength: maxLength(100)
      // },
      credit_limit: {
        required,
        maxValue(value) {
          if (!this.$helpers.isAgentLevel()) {
            return maxValue(this.max_credit_limit)(value)
          } else {
            return maxValue(this.max_member_credit_limit)(value)
          }
        }
      },
      member_credit_limit: {
        required(value) {
          return !this.$helpers.isAgentLevel() ? required(value) : true;
        },
        maxValue(value) {
          let result = value
          if (result > this.max_member_credit_limit) {
            result = this.max_member_credit_limit
          }
          if (result > this.credit_limit) {
            result = this.credit_limit
          }
          return maxValue(result)(value)
        }
      },
      win_limit: {
        required(value) {
          return this.$helpers.isAgentLevel() &&
            this.$store.getters.isLivecasinoPlatformEnabled
            ? required(value)
            : true;
        }
      },
      payment_option: {
        required(value) {
          return !this.$helpers.isAgentLevel() ? required(value) : true;
        }
      }
    }
  },  
  computed: {
    isDayEnabled() {
      return this.$helpers.isDayEnabled();
    },
    isDayEnabledList() {
      return this.$helpers.isDayEnabledList();
    },
    accountType() {
      return this.$store.getters.accountType
    },
    accountIdMinLength() {
      return this.$helpers.isAgentLevel() ? 3 : 2
    },
    accountIdMaxLength() {
      if (this.$helpers.isAgentLevel()) {
        return 3
      }
      return this.accountType == 6 ? 3 : 2
    },
    title_credit_limit: function() {
      if (!this.$helpers.isAgentLevel()) {
        return this.$t("ui.max") + " = " + this.$helpers.numberFormat(this.max_credit_limit);
      } else {
        return this.title_member_credit_limit + "  " + this.$t("ui.credit_limit") + " = " + this.$helpers.numberFormat(this.max_credit_limit);
      }
    },
    max_credit_limit: function() {
      return this.$store.getters.getAccountCreditLimit - this.$store.getters.getCreditUsedDownline;
    },
    title_member_credit_limit: function() {
      return this.$t("ui.max") + " = " + this.$helpers.numberFormat(this.max_member_credit_limit);
    },
    max_member_credit_limit: function() {
      return this.$store.getters.getAccountMemberCreditLimit;
    }
  },
  watch: {
    password(value) {
      if (!value) {
        this.passwordErrors = [];
        this.passwordStrength = { score: 0, strength: "", badgeClass: "text-muted" };
        return;
      }
      const result = this.$helpers.validatePassword(value);
      this.passwordErrors = result.errors;
      const strengthStyles = {
        Weak: { badgeClass: "text-danger" },
        Fair: { badgeClass: "text-warning" },
        Strong: { badgeClass: "text-primary" },
        "Very Strong": { badgeClass: "text-success" }
      };
      const style = strengthStyles[result.strength] || { badgeClass: "text-muted" };
      this.passwordStrength = {
        score: result.score,
        strength: result.strength,
        badgeClass: style.badgeClass
      };
    }
  },
  beforeMount: function() {
    this.$helpers.getSchedule()
  },
  mounted: function() {
    this.$helpers.getCreditLimit(this.$store.getters.accountID,this.$store.getters.accountType)
    // this.$helpers.getSchedule()
    this.$helpers.getWallet()
    this.$helpers.getPlatform()
    if(this.search_id != "") {
      this.search()
    }
  },
  methods: {
    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
          $event.preventDefault();
      }
    },
    randomID() {
      let characters = "abcdefghijklmnopqrstuvwxyz"
      let charLength = characters.length
      this.account_id = ""
      for (let i=0; i < 3; i++) {
        this.account_id += characters.charAt(Math.floor(Math.random() * charLength))
      }
      this.$v.account_id.$touch()
    },
    reset: function() {
      this.$v.$reset()
      this.passwordStrength = { score: 0, strength: "", badgeClass: "text-muted" };
      this.passwordErrors = [];
      this.submission.success = true
      this.submission.status = ""
    },
    clear: function() {
      this.$store.dispatch("user/setSelectedID", "")
      this.$store.dispatch("user/setSelectedType", "")
      this.search_id = ""
      this.account_id = ""
      this.full_name = ""
      this.password = ""
      // this.confirm_password = "";
      this.contact_phone = ""
      this.contact_email = ""
      this.credit_limit = "0"
      this.member_credit_limit = this.$helpers.isAgentLevel() ? "0" : ""
      this.win_limit = "0"
      this.daily_reset = 0
      this.$nextTick(() => {
        this.reset()
      });
    },
    search: function() {
      this.isDirectDownline()
    },
    getChildBetLimit: function() {
      let account_id = this.search_id
      let path = this.$refs.betLimitSettings.$v
      this.loading = true
      this.$store
        .dispatch("user/getChildBetLimit", { account_id })
        .then(response => {
          this.loading = false
          if (response.data.blSB.length > 0) {
            path.soccer_min_bet.$model = response.data.blSB[6].min_bet.toString()
            path.soccer_max_bet.$model = response.data.blSB[6].max_bet.toString()
            path.soccer_max_per_match.$model = response.data.blSB[6].max_per_match.toString()
            path.basketball_min_bet.$model = response.data.blSB[1].min_bet.toString()
            path.basketball_max_bet.$model = response.data.blSB[1].max_bet.toString()
            path.basketball_max_per_match.$model = response.data.blSB[1].max_per_match.toString()
            path.tennis_min_bet.$model = response.data.blSB[7].min_bet.toString()
            path.tennis_max_bet.$model = response.data.blSB[7].max_bet.toString()
            path.tennis_max_per_match.$model = response.data.blSB[7].max_per_match.toString()
            path.baseball_min_bet.$model = response.data.blSB[0].min_bet.toString()
            path.baseball_max_bet.$model = response.data.blSB[0].max_bet.toString()
            path.baseball_max_per_match.$model = response.data.blSB[0].max_per_match.toString()
            path.parlay_min_bet.$model = response.data.blSB[5].min_bet.toString()
            path.parlay_max_bet.$model = response.data.blSB[5].max_bet.toString()
            path.parlay_max_per_match.$model = response.data.blSB[5].max_per_match.toString()
            path.esports_min_bet.$model = response.data.blSB[3].min_bet.toString()
            path.esports_max_bet.$model = response.data.blSB[3].max_bet.toString()
            path.esports_max_per_match.$model = response.data.blSB[3].max_per_match.toString()
            path.others_min_bet.$model = response.data.blSB[4].min_bet.toString()
            path.others_max_bet.$model = response.data.blSB[4].max_bet.toString()
            path.others_max_per_match.$model = response.data.blSB[4].max_per_match.toString()

            path.cs_min_bet.$model = response.data.blSB[2].min_bet.toString()
            path.cs_max_bet.$model = response.data.blSB[2].max_bet.toString()
            path.cs_max_per_match.$model = response.data.blSB[2].max_per_match.toString()

            if (this.$helpers.isAgentLevel()) {
              path.livecasino_bet_limit_packages.$model = response.data.blLC[0].bet_limit_package
              path.lotto_bet_limit_packages.$model = response.data.blLO[0].bet_limit_package
              path.keno_bet_limit_packages.$model = response.data.blKN[0].bet_limit_package
              path.cockfight_bet_limit_packages.$model = response.data.blCF[0].bet_limit_package
              path.lottery_bet_limit_packages.$model = response.data.blLT[0].bet_limit_package
            } else {
              path.livecasino_bet_limit_packages.$model = response.data.blLC[0].bet_limit_package.split(",")
              path.lotto_bet_limit_packages.$model = response.data.blLO[0].bet_limit_package.split(",")
              path.keno_bet_limit_packages.$model = response.data.blKN[0].bet_limit_package.split(",")
              path.cockfight_bet_limit_packages.$model = response.data.blCF[0].bet_limit_package.split(",")
              path.lottery_bet_limit_packages.$model = response.data.blLT[0].bet_limit_package.split(",")
            }
          } else {
            let allRefs = this.$refs.betLimitSettings.$refs
            for (var ref in allRefs) {
              switch(ref){
                case "livecasino_bet_limit_packages":
                case "lotto_bet_limit_packages":
                case "keno_bet_limit_packages":
                case "cockfight_bet_limit_packages":
                case "lottery_bet_limit_packages":
                  this.$refs.betLimitSettings[ref] = "A"
                  break
                default:
                  this.$refs.betLimitSettings[ref] = 0
                  break
              }
            }
          }
        })
        .catch(response => {
          // console.log("child1", response)
          this.loading = false
        });
    },
    getChildCommission: function() {
      let account_id = this.search_id
      this.loading = true
      this.$store
        .dispatch("user/getChildCommission", { account_id })
        .then(response => {
          this.loading = false
          let path = this.$refs.commSettings.$v
          if (response.data.cmSB.length > 0) {
            if (!this.$helpers.isAgentLevel()) {
              path.comm_sportsbook_hdp_packages.$model = this.$store.getters.getCommSBPackages
              path.comm_sportsbook_hdp_a.$model = response.data.cmSB[0].hdp_a
              path.comm_sportsbook_hdp_b.$model = response.data.cmSB[0].hdp_b
              path.comm_sportsbook_hdp_c.$model = response.data.cmSB[0].hdp_c
              path.comm_sportsbook_hdp_d.$model = response.data.cmSB[0].hdp_d
              path.comm_sportsbook_hdp_e.$model = response.data.cmSB[0].hdp_e
              path.comm_sportsbook_hdp_f.$model = response.data.cmSB[0].hdp_f
            } else {
              path.comm_sportsbook_hdp_packages.$model = response.data.cmSB[0].hdp_packages
              switch (response.data.cmSB[0].hdp_packages) {
                case "A":
                  path.comm_sportsbook_hdp_a.$model = response.data.cmSB[0].hdp_a
                  break;
                case "B":
                  path.comm_sportsbook_hdp_b.$model = response.data.cmSB[0].hdp_b
                  break;
                case "C":
                  path.comm_sportsbook_hdp_c.$model = response.data.cmSB[0].hdp_c
                  break;
                case "D":
                  path.comm_sportsbook_hdp_d.$model = response.data.cmSB[0].hdp_d
                  break;
                case "E":
                  path.comm_sportsbook_hdp_e.$model = response.data.cmSB[0].hdp_e
                  break;
                case "F":
                  path.comm_sportsbook_hdp_f.$model = response.data.cmSB[0].hdp_f
                  break;
              }
            }

            if(['MMK','MMO'].includes(this.$store.getters.getAccountCurrency)) {
              path.comm_hdp_mmo.$model = response.data.cmMMO[0].hdp
              path.comm_parlay_mmo_a.$model = response.data.cmMMO[0].parlay_a
              path.comm_parlay_mmo_b.$model = response.data.cmMMO[0].parlay_b
            }

            path.comm_sportsbook_1x2.$model = response.data.cmSB[0].one_x_two
            path.comm_sportsbook_others.$model = response.data.cmSB[0].others
            path.comm_casino.$model = response.data.cmLC[0].account_commission
            path.comm_slots.$model = response.data.cmSL[0].account_commission

            path.comm_lotto.$model = response.data.cmLO[0].account_commission
            path.comm_keno.$model = response.data.cmKN[0].account_commission
            path.comm_cockfight.$model = response.data.cmCF[0].account_commission
            path.comm_lottery_1d.$model = response.data.cmLT[0].one_d
            path.comm_lottery_2d.$model = response.data.cmLT[0].two_d
            path.comm_lottery_3d.$model = response.data.cmLT[0].three_d
            path.comm_lottery_4d.$model = response.data.cmLT[0].four_d

          } else {
            let allRefs = this.$refs.commSettings.$refs;
            for (var ref in allRefs) {
              if (ref == "comm_sportsbook_hdp_packages") {
                this.$refs.commSettings[ref] = "A";
              } else {
                this.$refs.commSettings[ref] = 0;
              }
            }
          }
        })
        .catch(response => {
          this.loading = false;
        });
    },
    getChildPositionTaking: function() {
      let account_id = this.search_id
      this.loading = true
      this.$store
        .dispatch("user/getChildPositionTaking", { account_id })
        .then(response => {
          this.loading = false
          let path = this.$refs.ptSettings.$refs
          if (response.data.ptSB.length > 0) {
            let data = response.data.ptSB
            if (response.data.ptLC) {
              path.ptTableRowLiveCasino.$v.livecasino_upline_pt.$model = response.data.ptLC[0].upline_pt
              path.ptTableRowLiveCasino.$v.livecasino_account_pt.$model = (data[0].account_type == 1) ? 0 : response.data.ptLC[0].account_pt
              path.ptTableRowLiveCasino.$v.livecasino_upline_remaining.$model = response.data.ptLC[0].upline_remaining
              path.ptTableRowLiveCasino.$v.livecasino_account_min.$model = response.data.ptLC[0].account_min
            }

            if (response.data.ptSL) {
              path.ptTableRowSlots.$v.slots_upline_pt.$model = response.data.ptSL[0].upline_pt
              path.ptTableRowSlots.$v.slots_account_pt.$model = (data[0].account_type == 1) ? 0 : response.data.ptSL[0].account_pt
              path.ptTableRowSlots.$v.slots_upline_remaining.$model = response.data.ptSL[0].upline_remaining
              path.ptTableRowSlots.$v.slots_account_min.$model = response.data.ptSL[0].account_min
            }

            path.ptTableRowSoccer.$v.soccer_hdp_upline_pt.$model = this.$helpers.getPTSB(data,"HDP","SOCCER","upline_pt");
            path.ptTableRowSoccer.$v.soccer_hdp_account_pt.$model = (data[0].account_type == 1) ? 0 : this.$helpers.getPTSB(data,"HDP","SOCCER","account_pt");
            path.ptTableRowSoccer.$v.soccer_hdp_upline_remaining.$model = this.$helpers.getPTSB(data,"HDP","SOCCER","upline_remaining");
            path.ptTableRowSoccer.$v.soccer_hdp_account_min.$model = this.$helpers.getPTSB(data,"HDP","SOCCER","account_min");
            path.ptTableRowSoccer.$v.soccer_1x2_upline_pt.$model = this.$helpers.getPTSB(data,"1X2","SOCCER","upline_pt");
            path.ptTableRowSoccer.$v.soccer_1x2_account_pt.$model = (data[0].account_type == 1) ? 0 : this.$helpers.getPTSB(data,"1X2","SOCCER","account_pt");
            path.ptTableRowSoccer.$v.soccer_1x2_upline_remaining.$model = this.$helpers.getPTSB(data,"1X2","SOCCER","upline_remaining");
            path.ptTableRowSoccer.$v.soccer_1x2_account_min.$model = this.$helpers.getPTSB(data,"1X2","SOCCER","account_min");
            path.ptTableRowSoccer.$v.soccer_others_upline_pt.$model = this.$helpers.getPTSB(data,"OTHERS","SOCCER","upline_pt");
            path.ptTableRowSoccer.$v.soccer_others_account_pt.$model = (data[0].account_type == 1) ? 0 : this.$helpers.getPTSB(data,"OTHERS","SOCCER","account_pt");
            path.ptTableRowSoccer.$v.soccer_others_upline_remaining.$model = this.$helpers.getPTSB(data,"OTHERS","SOCCER","upline_remaining");
            path.ptTableRowSoccer.$v.soccer_others_account_min.$model = this.$helpers.getPTSB(data,"OTHERS","SOCCER","account_min");

            path.ptTableRowParlay.$v.parlay_upline_pt.$model = this.$helpers.getPTSB(data,"PARLAY","PARLAY","upline_pt");
            path.ptTableRowParlay.$v.parlay_account_pt.$model = (data[0].account_type == 1) ? 0 : this.$helpers.getPTSB(data,"PARLAY","PARLAY","account_pt");
            path.ptTableRowParlay.$v.parlay_upline_remaining.$model = this.$helpers.getPTSB(data,"PARLAY","PARLAY","upline_remaining");
            path.ptTableRowParlay.$v.parlay_account_min.$model = this.$helpers.getPTSB(data,"PARLAY","PARLAY","account_min");

            if(['MMK','MMO'].includes(this.$store.getters.getAccountCurrency)) {
              path.ptTableRowSoccer.$v.hdp_mmo_upline_pt.$model = this.$helpers.getPTSB(data,"HDPMMO","SOCCER","upline_pt");
              path.ptTableRowSoccer.$v.hdp_mmo_account_pt.$model = (data[0].account_type == 1) ? 0 : this.$helpers.getPTSB(data,"HDPMMO","SOCCER","account_pt");
              path.ptTableRowSoccer.$v.hdp_mmo_upline_remaining.$model = this.$helpers.getPTSB(data,"HDPMMO","SOCCER","upline_remaining");
              path.ptTableRowSoccer.$v.hdp_mmo_account_min.$model = this.$helpers.getPTSB(data,"HDPMMO","SOCCER","account_min");

              path.ptTableRowParlay.$v.parlay_mmo_upline_pt.$model = this.$helpers.getPTSB(data,"PARLAYMMO","PARLAYMMO","upline_pt");
              path.ptTableRowParlay.$v.parlay_mmo_account_pt.$model = (data[0].account_type == 1) ? 0 : this.$helpers.getPTSB(data,"PARLAYMMO","PARLAYMMO","account_pt");
              path.ptTableRowParlay.$v.parlay_mmo_upline_remaining.$model = this.$helpers.getPTSB(data,"PARLAYMMO","PARLAYMMO","upline_remaining");
              path.ptTableRowParlay.$v.parlay_mmo_account_min.$model = this.$helpers.getPTSB(data,"PARLAYMMO","PARLAYMMO","account_min");
            }

            if (response.data.ptLO) {
              path.ptTableRowLotto.$v.lotto_upline_pt.$model = response.data.ptLO[0].upline_pt
              path.ptTableRowLotto.$v.lotto_account_pt.$model = (data[0].account_type == 1) ? 0 : response.data.ptLO[0].account_pt
              path.ptTableRowLotto.$v.lotto_upline_remaining.$model = response.data.ptLO[0].upline_remaining
              path.ptTableRowLotto.$v.lotto_account_min.$model = response.data.ptLO[0].account_min
            }

            if (response.data.ptKN) {
              path.ptTableRowKeno.$v.keno_upline_pt.$model = response.data.ptKN[0].upline_pt
              path.ptTableRowKeno.$v.keno_account_pt.$model = (data[0].account_type == 1) ? 0 : response.data.ptKN[0].account_pt
              path.ptTableRowKeno.$v.keno_upline_remaining.$model = response.data.ptKN[0].upline_remaining
              path.ptTableRowKeno.$v.keno_account_min.$model = response.data.ptKN[0].account_min
            }

            if (response.data.ptCF) {
              path.ptTableRowCockfight.$v.cockfight_upline_pt.$model = response.data.ptCF[0].upline_pt
              path.ptTableRowCockfight.$v.cockfight_account_pt.$model = (data[0].account_type == 1) ? 0 : response.data.ptCF[0].account_pt
              path.ptTableRowCockfight.$v.cockfight_upline_remaining.$model = response.data.ptCF[0].upline_remaining
              path.ptTableRowCockfight.$v.cockfight_account_min.$model = response.data.ptCF[0].account_min
            }

            if (response.data.ptLT) {
              path.ptTableRowLottery.$v.lottery_1d_upline_pt.$model = response.data.ptLT[0].upline_pt
              path.ptTableRowLottery.$v.lottery_1d_account_pt.$model = (data[0].account_type == 1) ? 0 : response.data.ptLT[0].account_pt
              path.ptTableRowLottery.$v.lottery_1d_upline_remaining.$model = response.data.ptLT[0].upline_remaining
              path.ptTableRowLottery.$v.lottery_1d_account_min.$model = response.data.ptLT[0].account_min

              path.ptTableRowLottery.$v.lottery_2d_upline_pt.$model = response.data.ptLT[1].upline_pt
              path.ptTableRowLottery.$v.lottery_2d_account_pt.$model = (data[0].account_type == 1) ? 0 : response.data.ptLT[1].account_pt
              path.ptTableRowLottery.$v.lottery_2d_upline_remaining.$model = response.data.ptLT[1].upline_remaining
              path.ptTableRowLottery.$v.lottery_2d_account_min.$model = response.data.ptLT[1].account_min
            }
          } else {
            let allRefs = this.$refs.ptSettings.$refs;
            for (var refType in allRefs) {
              let refList = this.$refs.ptSettings.$refs[refType].$refs;
              for (var ref in refList) {
                this.$refs.ptSettings.$refs[refType][ref] = 0;
              }
            }
          }

          this.searchAcc = true;
        })
        .catch(response => {
          // console.log("Failed:getChildPositionTaking", response);
          this.loading = false;
        });
    },
    isDirectDownline: function() {
      let account_id = this.search_id;
      this.$store
        .dispatch("user/checkDirectDownline", { account_id })
        .then(response => {
          if (response.success) {
            this.getChildBetLimit();
            this.getChildCommission();
            this.getChildPositionTaking();
          }
        })
        .catch(response => {
          // console.log("child2", response);
          this.loading = false;
        });
    },
    isValidForm() {
      this.$refs.ptSettings.$refs.ptTableRowSoccer.$v.$touch()
      this.$refs.ptSettings.$refs.ptTableRowParlay.$v.$touch()
      this.$refs.ptSettings.$refs.ptTableRowLiveCasino.$v.$touch()
      this.$refs.ptSettings.$refs.ptTableRowSlots.$v.$touch()
      this.$refs.ptSettings.$refs.ptTableRowLotto.$v.$touch()
      this.$refs.ptSettings.$refs.ptTableRowKeno.$v.$touch()
      this.$refs.ptSettings.$refs.ptTableRowCockfight.$v.$touch()
      this.$refs.ptSettings.$refs.ptTableRowLottery.$v.$touch()
      this.$refs.commSettings.$v.$touch()
      this.$refs.betLimitSettings.$v.$touch()
      this.$v.$touch()

      return (
        this.$refs.ptSettings.$refs.ptTableRowSoccer.$v.$invalid ||
        this.$refs.ptSettings.$refs.ptTableRowParlay.$v.$invalid ||
        this.$refs.ptSettings.$refs.ptTableRowLiveCasino.$v.$invalid ||
        this.$refs.ptSettings.$refs.ptTableRowSlots.$v.$invalid ||
        this.$refs.ptSettings.$refs.ptTableRowLotto.$v.$invalid ||
        this.$refs.ptSettings.$refs.ptTableRowKeno.$v.$invalid ||
        this.$refs.ptSettings.$refs.ptTableRowCockfight.$v.$invalid ||
        this.$refs.ptSettings.$refs.ptTableRowLottery.$v.$invalid ||
        this.$refs.commSettings.$v.$invalid ||
        this.$refs.betLimitSettings.$v.$invalid ||
        this.$v.$invalid
      );
    },
    formPtJson: function() {
      let allRefs = this.$refs.ptSettings.$refs;
      for (var refType in allRefs) {
        let refList = this.$refs.ptSettings.$refs[refType].$refs;
        for (var ref in refList) {
          this.ptJSON[ref] = this.$refs.ptSettings.$refs[refType][ref];
        }
      }
    },
    formCmJson: function() {
      let allRefs = this.$refs.commSettings.$refs;
      for (var ref in allRefs) {
        this.cmJSON[ref] = this.$refs.commSettings[ref];
      }

      if (this.$helpers.isAgentLevel()) {
        let group = this.$refs.commSettings.$refs.comm_sportsbook_hdp_packages.value.toLowerCase();
        let comm = "comm_sportsbook_hdp_" + group;
        this.cmJSON.comm_sportsbook_hdp_a = this.$refs.commSettings[comm];
      }
    },
    formBlJson: function() {
      let allRefs = this.$refs.betLimitSettings.$refs;
      for (var ref in allRefs) {
        this.blJSON[ref] = this.$refs.betLimitSettings[ref];
      }
    },
    formScheduleJson: function() {
      let allRefs = this.payment_option;
      for (let i in this.schJSON) {
        if(i == "schedule_1") {
          this.schJSON[i] = true;
        } else {
          this.schJSON[i] = false;
        }
      }
      for (let i = 0; i < allRefs.length; i++) {
        this.schJSON[allRefs[i]] = true;
      }
    },
    submit: function() {
      this.reset();
      if (!this.isValidForm()) {
        this.loading = true;
        this.$swal({
          title: this.$t("ui.status"),
          text: this.$t("message.create_new_account_confirm"),
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            this.createAccount();
          } else if (
            // Read more about handling dismissals
            result.dismiss === "cancel"
          ) {
            this.loading = false;
            this.$swal({
              title: this.$t("ui.cancel"),
              text: this.$t("message.create_new_account_cancel"),
              type: "error"
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        });
      }
    },
    createAccount: function() {
      this.formPtJson();
      this.formCmJson();
      this.formBlJson();
      this.formScheduleJson();
      let currency = this.$store.getters.getAccountCurrency
      let account_id = this.account_id;
      let full_name = this.full_name;
      let password = this.password;
      let contact_phone = this.contact_phone;
      let contact_email = this.contact_email;
      let credit_limit = this.credit_limit;
      let member_credit_limit = this.member_credit_limit;
      let win_limit_multiplier = this.win_limit;
      let daily_reset = this.daily_reset ? 1 : 0;
      let pt = this.ptJSON;
      let cm = this.cmJSON;
      let bl = this.blJSON;
      let payment = this.schJSON;
      this.$store
        .dispatch("user/addAccount", {
          currency,
          account_id,
          full_name,
          password,
          contact_phone,
          contact_email,
          credit_limit,
          member_credit_limit,
          win_limit_multiplier,
          daily_reset,
          payment,
          pt,
          cm,
          bl
        })
        .then(response => {
          this.submission.success = response.success;
          this.submission.status = response.errorTag;
          if (this.submission.success == true) {
            let copyID =
              this.$store.getters.accountType != 6
                ? this.$store.getters.accountID + account_id
                : account_id;
            this.loading = false;
            this.clear();
            this.$swal({
              title: this.$t("title.account_creation"),
              html:
                "<div>" +
                this.$t("message.create_new_account_success") +
                "</div><br/>" +
                "<div id='text-to-copy'>" +
                this.$t("ui.account_id") +
                ": <strong>" +
                copyID +
                "</strong><br/>" +
                this.$t("ui.password") +
                ": <strong>" +
                password +
                "</strong></div>",
              type: "success",
              showCancelButton: true,
              confirmButtonText: this.$t("ui.copy"),
              cancelButtonText: this.$t("ui.ok"),
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm.value) {
                this.$helpers.selectText("text-to-copy");
                try {
                  var successful = document.execCommand("copy");
                  this.$swal(
                    this.$t("ui.succeed"),
                    this.$t("message.copy_success"),
                    "success"
                  );
                  this.cancel();
                } catch (ex) {
                  this.$swal(
                    this.$t("ui.fail"),
                    this.$t("message.copy_failed"),
                    "error"
                  );
                }
              } else if (
                // Read more about handling dismissals
                isConfirm.dismiss === "cancel"
              ) {
                this.cancel();
              }
            });
          }
        })
        .catch(response => {
          this.loading = false;
          this.submission.success = response.success;
          this.submission.status = this.$t("message." + response.errorTag);
        });
    },
    cancel: function() {
      this.$router.push("/accountList");
    }
  }
};
</script>